import React from 'react';

import Button from '@gds/Button/Button';

import styles from './ApplyButton.module.css';

interface ApplyButtonProps {
  handleApply: () => void;
  ctaText: string;
  disabled?: boolean;
}

const ApplyButton: React.FC<ApplyButtonProps> = ({ handleApply, ctaText, disabled }) => {
  return (
    <div className={styles.applyButtonWrapper}>
      <Button
        className={styles.applyButton}
        onClick={handleApply}
        data-test-id="apply-button"
        disabled={disabled}
      >
        {ctaText}
      </Button>
    </div>
  );
};

export default ApplyButton;
